import { useState, useEffect } from 'preact/hooks'

export function useScreen(initial) {

	const [screen, setScreen] = useState(initial)

	const goTo = (screen, location = window.location, addHistoryState = true) => {
		setTimeout(() => setScreen(screen), 20)
		addHistoryState && window.history.pushState(screen, '', location)
	}

	const goToUrl = url => window.location = url

	const onPopState = event => {
		if (event.state) goTo(event.state, window.location, false)
	}

	// initial history state on load
	useEffect(() => {
		history.replaceState(screen, '', window.location) 
		window.addEventListener('popstate', onPopState)
		return () => window.removeEventListener('popstate', onPopState)
	}, [])

	return { screen, goTo, goToUrl }
}